import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-deepgreen text-white pt-16 pb-8 px-6 border-t-4 border-gold">
      <div className="max-w-7xl mx-auto grid gap-12 md:grid-cols-2 lg:grid-cols-4 mb-12" data-aos="fade-up">
        
        {/* Column 1: Brand & About */}
        <div className="space-y-4">
          <h3 className="text-2xl font-serif font-bold text-gold mb-4">ENW Advocates</h3>
          <p className="text-gray-300 text-sm leading-relaxed">
            Restoring public confidence in the legal profession through professionalism, humility, and integrity. We provide strategic legal solutions tailored to your needs.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div>
          <h4 className="text-lg font-bold text-gold mb-6">Quick Links</h4>
          <ul className="space-y-3 text-sm text-gray-300">
            <li><HashLink smooth to="/#about" className="hover:text-gold transition">About Us</HashLink></li>
            <li><Link to="/team" className="hover:text-gold transition">Our Team</Link></li>
            <li><HashLink smooth to="/#services" className="hover:text-gold transition">Services</HashLink></li>
            <li><HashLink smooth to="/#contact" className="hover:text-gold transition">Contact Us</HashLink></li>
            <li><Link to="/login" className="hover:text-gold transition">Admin Portal</Link></li>
          </ul>
        </div>

        {/* Column 3: Practice Areas */}
        <div>
          <h4 className="text-lg font-bold text-gold mb-6">Practice Areas</h4>
          <ul className="space-y-3 text-sm text-gray-300">
            <li><HashLink smooth to="/#litigation-details" className="hover:text-gold transition">Litigation</HashLink></li>
            <li><HashLink smooth to="/#corporate-details" className="hover:text-gold transition">Corporate Law</HashLink></li>
            <li><HashLink smooth to="/#realestate-details" className="hover:text-gold transition">Real Estate</HashLink></li>
            <li><HashLink smooth to="/#labour-details" className="hover:text-gold transition">Employment Law</HashLink></li>
            <li><HashLink smooth to="/#family-details" className="hover:text-gold transition">Family Law</HashLink></li>
          </ul>
        </div>

        {/* Column 4: Contact Info */}
        <div>
          <h4 className="text-lg font-bold text-gold mb-6">Contact Us</h4>
          <ul className="space-y-4 text-sm text-gray-300">
            <li className="flex items-start gap-3">
              <span className="text-gold mt-1">📍</span>
              <span>Ground Floor, Professional Centre,<br/>Parliament Road, Nairobi</span>
            </li>
            <li className="flex items-center gap-3">
              <span className="text-gold">📞</span>
              <a href="tel:+254759738111" className="hover:text-gold">+254 759 738 111</a>
            </li>
            <li className="flex items-center gap-3">
              <span className="text-gold">✉️</span>
              <a href="mailto:odiranandaadvocate@gmail.com" className="hover:text-gold">odiranandaadvocate@gmail.com</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
        <p>&copy; {new Date().getFullYear()} Elvis Nanda, Weke & Company Advocates. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
